
import {Component, Vue} from 'vue-property-decorator';
import baseUrl, {imageUrl} from "@/constants";
@Component({
  name: "integrityDemoDialog",
  components: {},
})
export default class Home extends Vue {
  baseUrl = baseUrl
  imageUrl = imageUrl
  detailObj = {
    data: {} as any,
    dialog: false
  }
  private orgInfoDefault = {
    orgNameId: '',
    orgId: '',
    orgName: '',
    title: '',
    logo: '',
    photo: '',
    introduction: '',
    culture: '',
    integrityMeasurement: ''
  }
  setData(row: any) {
    this.detailObj.data = Object.assign({}, this.orgInfoDefault, row);
    this.detailObj.dialog = true;
  }
}
